import * as React from 'react';
import { withTranslation } from '@wix/fe-essentials/i18n';
import MessageBox from './MessageBox';
import { Modal } from '@wix/design-system';
const PriceQuoteDialog = ({ onClose, isOpen, businessName, withInvoice = false, harmonyTheme, t, }) => {
    return (React.createElement(Modal, { shouldCloseOnOverlayClick: true, isOpen: isOpen, onRequestClose: onClose, contentLabel: "" },
        React.createElement(MessageBox, { businessName: businessName, onClose: onClose, withInvoice: withInvoice, harmonyTheme: harmonyTheme })));
};
export default withTranslation(['invoice-view', 'locale-data'])(PriceQuoteDialog);
//# sourceMappingURL=PriceQuoteDialog.js.map